import { FileInput } from 'lucide-react';
import { useParams, Link } from 'react-router-dom';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/new/components/shadcn/tooltip';
import { useStore } from '@/store';

export const FullDocLink = ({ docId }: { docId: string }) => {
  const { matterId, subsetId } = useParams();
  const { closeReferenceDrawer } = useStore();

  return (
    <TooltipProvider delayDuration={0} skipDelayDuration={0}>
      <Tooltip>
        <TooltipTrigger
          asChild
          onClick={() => {
            closeReferenceDrawer();
          }}
        >
          <Link to={`/matters/${matterId}/subsets/${subsetId}/docs/${docId}`}>
            <div className="group flex cursor-pointer items-center rounded-lg border-2 border-blue-300 bg-blue-50 px-1.5 py-1 shadow-xl transition-all hover:border-blue-400 hover:bg-blue-100">
              <FileInput className="h-4 w-4 text-blue-600 transition-transform group-hover:scale-110" />
            </div>
          </Link>
        </TooltipTrigger>
        <TooltipContent>
          <p>View in documents page</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
